import React, { useState, useEffect, useCallback, useRef } from "react";
import { labelMapping } from "../../../../src/utils/fileMappings";
import { postBatchData } from "../../../API/litigationApis.js";
import { getLitigationClients, getLitigationBranches } from "../../../API/litigationApis.js";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import UploadProgressBar from "../../../../src/ui/UploadProgressBar";
import BatchUploadHandler from "../../../../src/ui/BatchUploadHandler";
import ContentLoader from "../../../../src/Components/ContentLoader";
import useGeneralStore from "../../../../src/store/generalStore";
import Steps from "../../../../src/ui/Steps";
import SelectDropdown from "../../../../src/ui/forms/SelectDropdown";
import ExcelFileInput from "../../../../src/ui/ExcelFileInput";

import useMappings from "../../../hooks/useMappings.js";
import useForm from "../../../hooks/useForm.js";
import useStep from "../../../hooks/useStep.js";
import { useBatchUploadHandler } from "../../../hooks/useBatchUploadHandler.js";

const stepValues = {
    DETAILS: "details",
    IMPORT_FILES: "import_files",
    MAP_COULUMNS: "map_columns",
};

const reliefSoughtOptions = [
    { label: "Civil Suit", value: "civil_suit" },
    { label: "NCLT", value: "nclt" },
    { label: "High Court", value: "high_court" },
    { label: "DRT", value: "drt" },
    { label: "Execution Petition (EP)", value: "execution_petition" },
    { label: "Original Application (OA)", value: "original_application" },
];
const CaseCategory = [
    { label: "Summary Suit", value: "summary_suit" },
    { label: "Commercial Suit", value: "comm_suit" },
    { label: "Execution Petition", value: "pre_ep" },
    { label: "Mediation Application", value: "mediation_application" },
    { label: "Interim Application", value: "interim_application" },
    { label: "Loan Recall Notice", value: "loan_recall_notice" },
    { label: "Sec 95", value: "sec_95"}
];
const stateOptions = [
    { label: "Andhra Pradesh", value: "andhra_pradesh" },
    { label: "Arunachal Pradesh", value: "arunachal_pradesh" },
    { label: "Assam", value: "assam" },
    { label: "Bihar", value: "bihar" },
    { label: "Chhattisgarh", value: "chhattisgarh" },
    { label: "Delhi", value: "delhi" },
    { label: "Goa", value: "goa" },
    { label: "Gujarat", value: "gujarat" },
    { label: "Haryana", value: "haryana" },
    { label: "Himachal Pradesh", value: "himachal_pradesh" },
    { label: "Jharkhand", value: "jharkhand" },
    { label: "Karnataka", value: "karnataka" },
    { label: "Kerala", value: "kerala" },
    { label: "Madhya Pradesh", value: "madhya_pradesh" },
    { label: "Maharashtra", value: "maharashtra" },
    { label: "Manipur", value: "manipur" },
    { label: "Meghalaya", value: "meghalaya" },
    { label: "Mizoram", value: "mizoram" },
    { label: "Nagaland", value: "nagaland" },
    { label: "Odisha", value: "odisha" },
    { label: "Punjab", value: "punjab" },
    { label: "Rajasthan", value: "rajasthan" },
    { label: "Sikkim", value: "sikkim" },
    { label: "Tamil Nadu", value: "tamil_nadu" },
    { label: "Telangana", value: "telangana" },
    { label: "Tripura", value: "tripura" },
    { label: "Uttar Pradesh", value: "uttar_pradesh" },
    { label: "Uttarakhand", value: "uttarakhand" },
    { label: "West Bengal", value: "west_bengal" },
    { label: "Other", value: "other" },
];

const jurisdictionOptions = [
    { label: "District Court", value: "district_court" },
    { label: "High Court", value: "high_court" },
    { label: "Supreme Court", value: "supreme_court" },
    { label: "DRT", value: "drt" },
    { label: "NCLT", value: "nclt" },
    { label: "Consumer Court", value: "consumer_court" },
    { label: "Other", value: "other" },
];

const MultiSelectDropdown = ({ options, value = [], onChange, placeholder }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleOptionClick = (optionValue) => {
        const newValue = value.includes(optionValue)
            ? value.filter((v) => v !== optionValue)
            : [...value, optionValue];
        onChange(newValue);
    };
    const getDisplayText = () => {
        if (value.length === 0) return placeholder;
        if (value.length === 1) {
            const option = options.find((opt) => opt.value === value[0]);
            return option ? option.label : "";
        }
        return `${value.length} selected`;
    };
    return (
        <div className="position-relative">
            <div
                className="form-control d-flex justify-content-between align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span>{getDisplayText()}</span>
                <i className={`fa fa-chevron-${isOpen ? "up" : "down"}`}></i>
            </div>
            {isOpen && (
                <div
                    className="position-absolute w-100 bg-white border rounded shadow-sm"
                    style={{ zIndex: 1000, maxHeight: "200px", overflowY: "auto" }}
                >
                    {options.map((option) => (
                        <div
                            key={option.value}
                            className={`p-2 border-bottom ${value.includes(option.value) ? "bg-light" : ""
                                }`}
                            style={{ cursor: "pointer" }}
                            onClick={() => handleOptionClick(option.value)}
                        >
                            <input
                                type="checkbox"
                                checked={value.includes(option.value)}
                                onChange={() => { }}
                                className="me-2"
                            />
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};


const BranchSearchDropdown = ({
    options, 
    value, 
    customValue, 
    onChange, 
    onCustomChange, 
    placeholder,
    disabled, 
}) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const MIN_CHARS = 3;
    const dropdownRef = useRef(null);

    // Determine the label to display in the input field
    const getDisplayText = useCallback(() => {
        if (value === "other") {
            return customValue || "Other (Custom Branch)";
        }
        const selectedOption = options.find((opt) => opt.label === value); 
        return selectedOption ? selectedOption.label : "";
    }, [value, customValue, options]);

    // Update search term when value/customValue changes (and dropdown is closed)
    useEffect(() => {
        if (!isOpen) {
            setSearchTerm(getDisplayText());
        }
    }, [value, customValue, options, isOpen, getDisplayText]);
    
    // Set initial text on first load/when disabled state changes
    useEffect(() => {
        if (disabled) {
            setSearchTerm(placeholder);
        } else {
            setSearchTerm(getDisplayText());
        }
    }, [getDisplayText, disabled, placeholder]);


    // --- START OF FIX ---
    const minCharsMet = searchTerm.trim().length >= MIN_CHARS;
    const normalizedSearchTerm = searchTerm.toLowerCase().trim();

    // Strict filter: Branches that actually match the search term (excluding 'other')
    const strictFilteredOptions = minCharsMet
        ? options.filter((option) =>
            option.label.toLowerCase().includes(normalizedSearchTerm) && option.value !== "other" 
          )
        : [];
    // --- END OF FIX ---


    const handleSearchChange = (e) => {
        const newSearchTerm = e.target.value;
        setSearchTerm(newSearchTerm);
        setIsOpen(true);

        // If the user starts typing, clear the selection 
        if (value !== "other") {
            const selectedOption = options.find((opt) => opt.label === value);
            
            if (selectedOption && !selectedOption.label.toLowerCase().startsWith(newSearchTerm.toLowerCase())) {
                onChange(""); 
            }
        }
    };

    const handleSelect = (option) => {
        if (option.value === "other") {
            onChange("other");
            onCustomChange(""); 
        } else {
            onChange(option.label); 
            onCustomChange(""); 
        }
        setSearchTerm(option.label); 
        setIsOpen(false);
    };

    const handleFocus = () => {
        if (disabled) return;
        setIsOpen(true);
        // Clear search term on focus if it currently displays a selected label
        if (value !== "" && value !== "other") {
             setSearchTerm("");
        }
    }

    const handleBlur = () => {
        // Delay closing to allow click event on option list
        setTimeout(() => {
             setIsOpen(false);
             // On blur, revert the search term to the actual selected/custom value label
             setSearchTerm(getDisplayText());
        }, 200); 
    };
    
    // Determine which options to show in the dropdown list
    let finalOptionsToShow = [];
    const otherOption = options.find(o => o.value === "other");
    
    
    if (minCharsMet) {
        const hasMatches = strictFilteredOptions.length > 0;

        if (hasMatches) {
            // If we have matches (valid partial search), show them PLUS 'Other' at the end.
            finalOptionsToShow = [...strictFilteredOptions];
            if (otherOption) {
                finalOptionsToShow.push(otherOption);
            }
        } else {
            // If minCharsMet is true AND there are NO branch matches (gibberish case), show ONLY 'Other'.
            if (otherOption) {
                 finalOptionsToShow = [otherOption];
            }
        }
    } else if (otherOption && disabled) {
    }
    
    // If the component is not disabled AND the selected value is 'other', we ensure 'Other' is the option.
    if (!disabled && value === 'other' && otherOption) {
        finalOptionsToShow = [otherOption];
    } else if (!minCharsMet && !disabled && value !== 'other') {
        finalOptionsToShow = [];
    }


    // Determine visibility based on min chars met AND having options to show (including 'Other')
    const isDropdownVisible = isOpen && (minCharsMet || value === 'other') && finalOptionsToShow.length > 0;

    // Show no results message only if the list is visible and the only option is 'Other'
    const showNoResultsMessage = isDropdownVisible 
        && finalOptionsToShow.length === 1 
        && finalOptionsToShow[0].value === "other"
        && normalizedSearchTerm.length >= MIN_CHARS; // Only show if they've typed enough to search
        
    // Fix finalOptionsToShow for the 'other' client case: 
    // If client is "Other" (and therefore disabled is false), we only want to show "Other" in the list.
    if (!disabled && options.length === 1 && options[0].value === 'other') {
        finalOptionsToShow = [otherOption];
    }


    return (
        <div className="position-relative">
            <input
                type="text"
                className="form-control"
                placeholder={disabled ? "Select client first" : placeholder}
                value={searchTerm}
                onChange={handleSearchChange}
                onFocus={handleFocus}
                disabled={disabled} // Disabled based on client selection
            />
            {isDropdownVisible && (
                <div
                    className="position-absolute w-100 bg-white border rounded shadow-sm"
                    style={{ zIndex: 1000, maxHeight: "200px", overflowY: "auto", top: '100%', left: 0 }}
                >
                    {finalOptionsToShow.map((option) => (
                        <div
                            key={option.value}
                            className={`p-2 border-bottom list-group-item-action ${
                                option.label === value || (option.value === "other" && value === "other")
                                ? "bg-light" 
                                : ""
                            }`}
                            style={{ cursor: "pointer" }}
                            onMouseDown={() => handleSelect(option)} // Use onMouseDown to trigger before onBlur
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
            {showNoResultsMessage && (
                <div className="alert alert-warning mt-2 p-1 text-center" role="alert" style={{ fontSize: '0.8rem' }}>
                    No specific branches found for "{searchTerm}". Select 'Other' to input custom value.
                </div>
            )}
            
        </div>
    );
};


export default function UploadNewBatch({ show, setShow, reload = () => { } }) {
    const showAlert = useGeneralStore((state) => state.open_alert);
    const [clientOptions, setClientOptions] = useState([]);
    // branchOptions now stores API results with additional manager details
    const [branchOptions, setBranchOptions] = useState([]); 
    // New state to hold raw branch data (including manager details) for auto-filling
    const [rawBranchData, setRawBranchData] = useState([]);
    const { updateMappings, getMappings } = useMappings({ type: "litigation" });
    const [loading, setLoading] = useState(false);
    
    // Helper to get today's date in YYYY-MM-DD format for the input type="date"
    const getTodayDate = () => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months start at 0!
        const dd = String(today.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`; // Note: Changed to YYYY-MM-DD for consistency and browser compatibility
    };

    const [details, handleDetails, resetDetails] = useForm({
        client_id: "", 
        client_name: "", // Kept for display/lookup if needed
        branch_id: "", // <-- NEW: Added to track branch ID
        branch_name: "", 
        assigned_by: "",
        assignment_date: getTodayDate(), // Set default to today's date
        client_email: "",
        client_contact_no: "",
        relief_sought: [],
        custom_client_name: "",
        custom_branch_name: "", 
    });
    const [showWarningModal, setShowWarningModal] = useState(false);
    const { activeStep, setActiveStep, steps, updateStep, resetSteps } = useStep([
        { title: "Details", completed: false, key: stepValues.DETAILS },
        { title: "Import File", completed: false, key: stepValues.IMPORT_FILES },
        { title: "Map Columns", completed: false, key: stepValues.MAP_COULUMNS },
    ]);
    const {
        progressValue,
        importDisabled,
        fileName,
        batchFile,
        matchedHeaderNames,
        handleHeaderChange,
        availableHeaderNames,
        handleFileValidation,
        getUploadHeaders,
        resetBatchUpload,
        SelectSheetModal,
    } = useBatchUploadHandler({ showProgress: true });

    const closeModal = () => {
        setShow(false);
        reload(); // Ensure reload is called if needed
        resetBatchUpload();
        setShowWarningModal(false);
        resetSteps();
        setLoading(false);
        resetDetails();
    };

    // Handle client selection - store name for API submission
    const handleClientChange = (clientId) => {
        if (clientId === "other") {
            handleDetails("client_name", "");
            handleDetails("custom_client_name", "");

            // Automatically set branch to "other" when client is "other"
            handleDetails("branch_id", ""); // Clear branch ID
            handleDetails("branch_name", "other");
            handleDetails("custom_branch_name", "");
            // Clear auto-filled fields when client is custom
            handleDetails("assigned_by", "");
            handleDetails("client_email", "");
            handleDetails("client_contact_no", "");
            
            // Set branch options to only "Other"
            setBranchOptions([{ label: "Other", value: "other" }]);
            setRawBranchData([]);

        } else {
            const selectedClient = clientOptions.find(client => client.value === clientId);
            handleDetails("client_name", selectedClient ? selectedClient.label : "");
            handleDetails("custom_client_name", "");
            
            // Reset dependent fields
            handleDetails("branch_id", ""); // Clear branch ID
            handleDetails("branch_name", "");
            handleDetails("custom_branch_name", "");
            handleDetails("assigned_by", "");
            handleDetails("client_email", "");
            handleDetails("client_contact_no", "");
            setBranchOptions([]); 
            setRawBranchData([]); // Clear raw data
        }
        handleDetails("client_id", clientId);
    };

    // Handle branch selection - UPDATED FOR AUTO-FILL AND ID
    const handleBranchChange = (branchValue) => {
        if (branchValue === "other") {
            handleDetails("branch_id", ""); // Clear branch ID
            handleDetails("branch_name", "other");
            handleDetails("custom_branch_name", "");
            
            // Clear auto-filled fields when 'Other' is selected
            handleDetails("assigned_by", "");
            handleDetails("client_email", "");
            handleDetails("client_contact_no", "");

        } else {
            // branchValue holds the actual branch label (branch_name)
            handleDetails("branch_name", branchValue);
            handleDetails("custom_branch_name", ""); 
            
            // Auto-fill manager details AND set branch ID
            const selectedBranchData = rawBranchData.find(b => b.branch_name === branchValue);
            if (selectedBranchData) {
                // Use || "" to handle potential null values in API response gracefully
                handleDetails("branch_id", selectedBranchData.id || ""); // <-- NEW: Set branch ID
                handleDetails("assigned_by", selectedBranchData.manager_name || "");
                handleDetails("client_email", selectedBranchData.manager_email_id || "");
                handleDetails("client_contact_no", selectedBranchData.manager_number || "");
                
                // Keep assignment date as today's date
            } else {
                handleDetails("branch_id", "");
                handleDetails("assigned_by", "");
                handleDetails("client_email", "");
                handleDetails("client_contact_no", "");
            }
        }
    };
    
    // Handle custom branch input
    const handleCustomBranchChange = (customName) => {
        handleDetails("custom_branch_name", customName);
    };

    const fetchBranchesByClient = async (clientId) => {
        if (clientId === "" || clientId === "other") {
            setBranchOptions([{ label: "Other", value: "other" }]);
            setRawBranchData([]);
            return;
        }

        try {
            const response = await getLitigationBranches(clientId); 
            if (response?.data?.results) {
                // Store raw data for lookup
                setRawBranchData(response.data.results); 
                
                // Format options for the searchable dropdown
                const options = response.data.results.map((branch) => ({
                    label: branch.branch_name, 
                    value: branch.branch_name, 
                }));
                // Add "Other" option
                options.push({ label: "Other", value: "other" });
                setBranchOptions(options);
            } else {
                setBranchOptions([{ label: "Other", value: "other" }]);
                setRawBranchData([]);
            }
        } catch (error) {
            console.error("Error fetching branches:", error);
            showAlert({ variant: "danger", msg: "Failed to fetch branches" });
            setBranchOptions([{ label: "Other", value: "other" }]);
            setRawBranchData([]);
        }
    }


    useEffect(() => {
        if (show) {
            getMappings();
            const fetchClients = async () => {
                try {
                    const response = await getLitigationClients();
                    if (response?.data?.results) {
                        const options = response.data.results.map((client) => ({
                            label: client.full_name,
                            value: client.id,
                        }));
                        // Add "Other" option
                        options.push({ label: "Other", value: "other" });
                        setClientOptions(options);
                    }
                } catch (error) {
                    console.error("Error fetching clients:", error);
                    showAlert({ variant: "danger", msg: "Failed to fetch clients" });
                }
            };
            fetchClients();
            // Set default date and reset branch options on modal open
            handleDetails("assignment_date", getTodayDate());
            setBranchOptions([{ label: "Other", value: "other" }]);
            setRawBranchData([]);
        }
    }, [show, getMappings, showAlert]);
    
    // useEffect to fetch branches when client_id changes
    useEffect(() => {
        if (details.client_id) {
            fetchBranchesByClient(details.client_id);
        } else {
            setBranchOptions([{ label: "Other", value: "other" }]);
            setRawBranchData([]);
        }
    }, [details.client_id]);

    // This function now builds the FormData with the correct keys for the API.
    const exportColumns = async () => {
        setLoading(true);
        try {
            const formData = new FormData();

           
            const finalClientValue = details?.client_id === "other"
                ? details?.custom_client_name // Send custom name for 'other'
                : details?.client_id; // Send client ID for specific client
                
            if (finalClientValue) formData.append("client_id", finalClientValue); 

            const finalBranchValue = details?.branch_name === "other"
                ? details?.custom_branch_name // Send custom name for 'other'
                : details?.branch_id; // Send branch ID for specific branch
            
            if (finalBranchValue) formData.append("branch_id", finalBranchValue); 


            if (details?.assigned_by) formData.append("assigned_by", details.assigned_by);
            if (details?.assignment_date) formData.append("assignment_date", details.assignment_date);
            if (details?.client_email) formData.append("email_id", details.client_email);
            if (details?.client_contact_no) formData.append("contact_no", details.client_contact_no);

            if (details?.relief_sought?.length) {
                formData.append("relief_sought", details.relief_sought.join(','));
            }
            
            // Jurisdiction fields (not used in state, court dropdowns but included in exportColumns for completeness)
            
            // Send jurisdiction state (custom if "other" selected)
            const finalJurisdictionState = details?.jurisdiction_state === "" && details?.custom_jurisdiction_state
                ? details?.custom_jurisdiction_state
                : details?.jurisdiction_state;
            if (finalJurisdictionState) formData.append("jurisdiction_state", finalJurisdictionState);

            // Send jurisdiction court (custom if "other" selected)
            const finalJurisdictionCourt = details?.jurisdiction_court === "" && details?.custom_jurisdiction_court
                ? details?.custom_jurisdiction_court
                : details?.jurisdiction_court;
            if (finalJurisdictionCourt) formData.append("jurisdiction_court", finalJurisdictionCourt);

            if (batchFile) formData.append("case_file", batchFile);

            const uploadHeaders = getUploadHeaders();
            if (uploadHeaders) formData.append("column_rename_data", JSON.stringify(uploadHeaders));

            const res = await postBatchData(formData);

            // Fixed success condition - check for status:true OR res.data existence
            if (res && (res.status === true || res.data)) {
                showAlert({ variant: "success", msg: res?.message || "Imported Successfully" });
                closeModal();
            } else {
                showAlert({ variant: "danger", msg: res?.message || "Failed to import" });
            }
        } catch (error) {
            console.error("Error exporting columns:", error);
            const errorMsg = error.response?.data?.message || "Failed to import";
            showAlert({ variant: "danger", msg: errorMsg });
        }
        setLoading(false);
    };

    useEffect(() => {
        if (progressValue >= 100) {
            setActiveStep(stepValues.MAP_COULUMNS);
            updateStep({ stepKey: stepValues.IMPORT_FILES, completed: true });
        }
    }, [progressValue, setActiveStep, updateStep]);

    const validateDetailsStep = () => {
        const clientValid = details.client_id === "other"
            ? details.custom_client_name.trim() !== ""
            : details.client_id !== ""; // Check if ID is present

        const branchValid = details.branch_name === "other" 
            ? details.custom_branch_name.trim() !== ""
            : details.branch_id !== ""; // Check if ID is present

        return (
            clientValid &&
            branchValid &&
            details.assigned_by &&
            details.assignment_date &&
            details.client_email &&
            details.relief_sought.length > 0
        );
    };

    return (
        <>
            <Modal show={show} dialogClassName="modal-large" backdrop="static">
                <Modal.Header>
                    <Modal.Title>Upload New Batch File</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="py-4">
                        <Steps activeStep={activeStep} setActiveStep={setActiveStep} steps={steps} />
                    </div>
                    {activeStep === stepValues.DETAILS && (
                        <div className="py-5" style={{ minHeight: "500px" }}>
                            <div className="row justify-content-center mb-4">
                                <div className="col-6">
                                    <p className="mb-1">Client Name <span className="text-danger">*</span></p>
                                    <SelectDropdown
                                        options={clientOptions}
                                        placeholder="Choose Client"
                                        onChange={handleClientChange}
                                        value={details?.client_id}
                                    />
                                    {details?.client_id === "other" && (
                                        <input
                                            type="text"
                                            className="form-control mt-2"
                                            value={details?.custom_client_name}
                                            onChange={(e) => handleDetails("custom_client_name", e.target.value)}
                                            placeholder="Enter custom client name"
                                        />
                                    )}
                                </div>
                                <div className="col-6">
                                    <p className="mb-1">Branch Name <span className="text-danger">*</span></p>
                                    <BranchSearchDropdown
                                        options={branchOptions}
                                        placeholder={details.client_id ? "Type Branch Name (min 3 chars)" : "Select client first"}
                                        onChange={handleBranchChange}
                                        onCustomChange={handleCustomBranchChange}
                                        value={details?.branch_name} 
                                        customValue={details?.custom_branch_name}
                                        // ONLY disabled if no client is selected at all
                                        disabled={!details.client_id} 
                                    />
                                    {details?.branch_name === "other" && (
                                        <input
                                            type="text"
                                            className="form-control mt-2"
                                            value={details?.custom_branch_name}
                                            onChange={(e) => handleDetails("custom_branch_name", e.target.value)}
                                            placeholder="Enter custom branch name"
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="row justify-content-center mb-4">
                                <div className="col-6">
                                    <p className="mb-1">Assigned By <span className="text-danger">*</span></p>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={details?.assigned_by}
                                        onChange={(e) => handleDetails("assigned_by", e.target.value)}
                                        placeholder="Enter assigned by"
                                        // Auto-filled field should still be editable
                                    />
                                </div>
                                <div className="col-6">
                                    <p className="mb-1">Assignment Date <span className="text-danger">*</span></p>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={details?.assignment_date}
                                        onChange={(e) => handleDetails("assignment_date", e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="row justify-content-center mb-4">
                                <div className="col-6">
                                    <p className="mb-1">Client Email ID <span className="text-danger">*</span></p>
                                    <input
                                        type="email"
                                        className="form-control"
                                        value={details?.client_email}
                                        onChange={(e) => handleDetails("client_email", e.target.value)}
                                        placeholder="Enter client email"
                                         // Auto-filled field should still be editable
                                    />
                                </div>
                                <div className="col-6">
                                    <p className="mb-1">Client Contact Number</p>
                                    <input
                                        type="tel"
                                        className="form-control"
                                        value={details?.client_contact_no}
                                        onChange={(e) => handleDetails("client_contact_no", e.target.value)}
                                        placeholder="Enter contact number"
                                         // Auto-filled field should still be editable
                                    />
                                </div>
                            </div>
                            <div className="row justify-content-center mb-4">
                                <div className="col-6">
                                    <p className="mb-1">Relief Sought <span className="text-danger">*</span></p>
                                    <MultiSelectDropdown
                                        options={reliefSoughtOptions}
                                        value={details?.relief_sought}
                                        onChange={(val) => handleDetails("relief_sought", val)}
                                        placeholder="Select Relief Sought (Multiple selection allowed)"
                                    />
                                </div>
                                <div className="col-6">
                                    {/* Empty column for spacing */}
                                </div>
                            </div>
                        </div>
                    )}
                    {activeStep === stepValues.IMPORT_FILES && (progressValue <= 0 || progressValue >= 100) && (
                        <ExcelFileInput
                            onChange={(e) => {
                                if (e?.target?.files[0]?.size > 1e7) {
                                    showAlert({ variant: "danger", msg: "File size should be lesser than 10 MBs!" });
                                    return;
                                }
                                handleFileValidation(e);
                            }}
                        />
                    )}
                    {(activeStep === stepValues.IMPORT_FILES || activeStep === stepValues.MAP_COULUMNS) && progressValue > 0 && progressValue < 100 && (
                        <UploadProgressBar progressValue={progressValue} />
                    )}
                    {activeStep === stepValues.MAP_COULUMNS && (
                        <div className="py-5">
                            <BatchUploadHandler
                                availableHeaderNames={availableHeaderNames}
                                matchedHeaderNames={matchedHeaderNames}
                                labelMapping={labelMapping}
                                handleHeaderChange={handleHeaderChange}
                                automapping={true}
                            />
                        </div>
                    )}
                    {loading && <ContentLoader />}
                </Modal.Body>
                <Modal.Footer>
                    {activeStep === stepValues.IMPORT_FILES && (
                        <Button variant="primary" onClick={() => setActiveStep(stepValues.DETAILS)}>
                            Prev - Details
                        </Button>
                    )}
                    {activeStep === stepValues.MAP_COULUMNS && (
                        <Button variant="primary" onClick={() => setActiveStep(stepValues.IMPORT_FILES)}>
                            Prev - Import File
                        </Button>
                    )}
                    <Button variant="secondary" onClick={() => setShowWarningModal(true)}>
                        Cancel
                    </Button>
                    {activeStep === stepValues.DETAILS && (
                        <Button
                            variant="primary"
                            disabled={!validateDetailsStep()}
                            onClick={() => {
                                updateStep({ stepKey: stepValues.DETAILS, completed: true });
                                setActiveStep(stepValues.IMPORT_FILES);
                            }}
                        >
                            Next - Import File
                        </Button>
                    )}
                    {activeStep === stepValues.MAP_COULUMNS && (
                        <Button
                            variant="primary"
                            disabled={importDisabled || progressValue < 100}
                            className="collection_batch_upload_page_footer_import"
                            onClick={() => exportColumns()}
                        >
                            Import
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
            <SelectSheetModal />
            <Modal show={showWarningModal} backdrop="static" dialogClassName="modal-small resetModal">
                <Modal.Header>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body className="tab-m-body language-popup">
                    <div className="pt-4 pb-4 ps-3 text-center">The data you filled out will be lost. Are you sure?</div>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => closeModal()}>
                            Yes
                        </Button>
                        <Button variant="secondary" onClick={() => setShowWarningModal(false)}>
                            No
                        </Button>
                    </Modal.Footer>
                </Modal.Body>
            </Modal>
        </>
    );
}